import { CalendarCell } from "./CalendarCell.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { useCalendarGrid, useLocale } from "react-aria";
import { getWeeksInMonth } from "@internationalized/date";
//#region src/DatePicker/components/Calendar/CalendarGrid.tsx
const CalendarGrid = ({ state, poolOfDates, ...props }) => {
	const { locale } = useLocale();
	const { gridProps, headerProps, weekDays } = useCalendarGrid(props, state);
	const weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale);
	return /* @__PURE__ */ jsxs("table", {
		...gridProps,
		cellPadding: "0",
		className: "flex-1",
		children: [/* @__PURE__ */ jsx("thead", {
			...headerProps,
			className: "text-gray-600",
			children: /* @__PURE__ */ jsx("tr", { children: weekDays.map((day, index) => /* @__PURE__ */ jsx("th", {
				className: "text-type-common text-center font-normal",
				children: day
			}, `weekDays-${index}`)) })
		}), /* @__PURE__ */ jsx("tbody", { children: Array.from({ length: weeksInMonth }, (_, weekIndex) => /* @__PURE__ */ jsx("tr", { children: state.getDatesInWeek(weekIndex).map((date, i) => date ? /* @__PURE__ */ jsx(CalendarCell, {
			poolOfDates,
			state,
			date
		}, `calendar-cell-${i}`) : /* @__PURE__ */ jsx("td", {}, i)) }, `weekIndex-${weekIndex}`)) })]
	});
};
//#endregion
export { CalendarGrid };

//# sourceMappingURL=CalendarGrid.js.map